import { render } from "./ProductsPage.vue?vue&type=template&id=ebe51b5e&scoped=true&ts=true"
import script from "./ProductsPage.vue?vue&type=script&lang=ts"
export * from "./ProductsPage.vue?vue&type=script&lang=ts"

import "./ProductsPage.vue?vue&type=style&index=0&id=ebe51b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe51b5e"]])

export default __exports__